import { styled, TableCell, TableCellProps } from '@mui/material';

const FillWidthCell: React.FC<TableCellProps> = styled(
  TableCell
)<TableCellProps>(() => ({
  flex: '1 0 0',
}));

export default FillWidthCell;
